export enum StatusType {
  NEUTRAL = "neutral",
  ERROR = "error",
  ALERT = "alert",
  SUCCESS = "success"
}
